import { render, staticRenderFns } from "./edit2.vue?vue&type=template&id=52bf11af&scoped=true"
import script from "./edit2.vue?vue&type=script&lang=js"
export * from "./edit2.vue?vue&type=script&lang=js"
import style0 from "./edit2.vue?vue&type=style&index=0&id=52bf11af&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bf11af",
  null
  
)

export default component.exports